export const CODICI_CONTATORE = [
  'produzione',
  'uso_promiscuo',
  'consumi_esenti',
  'consumi_assoggettati',
  'ceduta',
  'ricevuta',
  'non_sottoposti',
  'altri',
] as const
export type CodiceContatore = (typeof CODICI_CONTATORE)[number]

/** La lettera e sola etichetta di presentazione: X copre due codici diversi. */
export const LETTERA_CONTATORE: Record<CodiceContatore, string> = {
  produzione: 'A',
  uso_promiscuo: 'B',
  consumi_esenti: 'C',
  consumi_assoggettati: 'E',
  ceduta: 'G',
  ricevuta: 'H',
  non_sottoposti: 'X',
  altri: 'X',
}

export const DESCRIZIONE_CONTATORE: Record<CodiceContatore, string> = {
  produzione: 'Produzione',
  uso_promiscuo: 'Uso promiscuo',
  consumi_esenti: 'Consumi propri esenti da accisa',
  consumi_assoggettati: 'Consumi propri assoggettati ad accisa',
  ceduta: 'Energia elettrica ceduta',
  ricevuta: 'Energia elettrica ricevuta',
  non_sottoposti: 'Consumi propri non sottoposti',
  altri: 'Altri contatori (non in dichiarazione)',
}

/** `altri` non entra in dichiarazione. */
export const CONTATORI_IN_DICHIARAZIONE: readonly CodiceContatore[] = CODICI_CONTATORE.filter(
  (c) => c !== 'altri',
)

export const TIPOLOGIE_IMPIANTO = [
  'cessione_parziale_esente',
  'cessione_parziale_commerciale',
  'cessione_totale',
  'altre_officine',
  'impianto_vendita',
  'non_configurato',
] as const
export type TipologiaImpianto = (typeof TIPOLOGIE_IMPIANTO)[number]

/** Solo tre tipologie hanno un codice nel tracciato ADM. */
export const CODICE_ADM_TIPOLOGIA: Partial<Record<TipologiaImpianto, string>> = {
  cessione_parziale_esente: '01',
  cessione_totale: '00',
  altre_officine: '02',
}

export const TIPOLOGIE_DICHIARANTE = [
  'licenza_rinnovabili_uso_esente',
  'licenza_cessione_consumatori_finali',
  'licenza_altra_officina',
  'autorizzazione_vendita_consumatore_finale',
] as const
export type TipologiaDichiarante = (typeof TIPOLOGIE_DICHIARANTE)[number]

/** CodAtt del tracciato semestrale (D.Lgs. 43/2025): enumerazione 1-4 del
 * soggetto obbligato, diversa da CODICE_ADM_TIPOLOGIA (00/01/02, tipologia
 * impianto annuale) — vedi D-10 in .work/backlog.md. */
export const CODICE_ATTIVITA_SEMESTRALE: Record<TipologiaDichiarante, string> = {
  licenza_rinnovabili_uso_esente: '1',
  licenza_cessione_consumatori_finali: '2',
  licenza_altra_officina: '3',
  autorizzazione_vendita_consumatore_finale: '4',
}

/* TipoSogg (L/A/N) non vive qui: e' una regola del tracciato, quindi un dato
 * versionato per anno e periodo — `tracciato.valoriTipoSoggetto` nei semi
 * `supabase/seed/regole-periodo-2026-*.json`, applicato da
 * `apps/worker/src/dichiarazione/carica.ts`. La funzione che stava qui era una
 * seconda copia della stessa regola, gia' presente come `case` in
 * `dichiarazione_completa`: entrambe rimosse nella review finale di SP4. */

export const QUADRI = ['A', 'B', 'C', 'E', 'G', 'H', 'J', 'L', 'M', 'Q', 'S', 'N', 'T'] as const
export type Quadro = (typeof QUADRI)[number]

export const PERIODI = ['annuale', 'semestre_1', 'semestre_2'] as const
export type Periodo = (typeof PERIODI)[number]

export const STATI_DICHIARAZIONE = [
  'letture_non_inserite',
  'bozza',
  'letture_da_controllare',
  'da_firmare',
  'da_inviare',
  'inviata',
  'errore_invio',
] as const
export type StatoDichiarazione = (typeof STATI_DICHIARAZIONE)[number]

export const STATI_IMPIANTO = ['attivo', 'inattivo', 'sospeso', 'archiviato'] as const
export type StatoImpianto = (typeof STATI_IMPIANTO)[number]
